/**
 * Make the coupon code ajax request.
 */

(function ($) {

	$(document).on('click', 'button[name=apply_coupon]', function (event) {
		event.preventDefault();

		var button = $(this);
		var buttonText = button.text();
		var code = button.siblings('input[name=coupon_code]').first().val();
		var nonce = button.siblings('input[name=woocommerce-coupon-nonce]').first().val();

		var data = {
			action: 'woocommerce_apply_coupon',
			coupon_code: code,
			security: nonce
		};
		button.text('Venter...');
		// Send it over to WordPress.
		$.post(woocommerce_params.ajax_url, data, function (returned_data) {
			if (returned_data.result === 'error') {
				button.siblings('div.message').text(returned_data.message);
			} else {
				setTimeout(function () {
					//reload with ajax
					$(document.body).trigger('wc_update_cart');
					$(document.body).trigger('update_checkout');
					button.siblings('div.message').empty();
				}, 2000);

				button.html(buttonText);
				button.siblings('div.message').html(returned_data);

				console.log(returned_data + code);
			}
		})
	});

})(jQuery);
